import styled, { css } from "styled-components";

interface ThumbProps {
  $xAxis?: boolean;
  $yAxis?: boolean;
  $visible: boolean;
}

export const Thumb = styled.div<ThumbProps>`
  ${({ $xAxis, $yAxis }) => {
    if ($xAxis)
      return css`
        height: 0.4rem !important;
        top: 0.2rem !important;
      `;
    if ($yAxis)
      return css`
        width: 0.4rem !important;
        left: 0.2rem !important;
      `;
  }}
  position: absolute !important;
  background-color: var(--text-gray-3) !important;
  transition: opacity 0.2s ease !important;
  opacity: ${({ $visible }) => ($visible ? "1" : "0")} !important;
  &:hover,
  &:active {
    opacity: 1 !important;
    background-color: var(--pressed-strong) !important;
  }
`;
